import React, { useEffect } from 'react';
import { Outlet, createSearchParams, useLocation } from 'react-router-dom';
import { useNavigate } from 'src/utils/useNavigate';
import routes from 'src/constants/routes';
import useAuthorization from 'src/dataHooks/useAuthorization';
import PageSpin from 'src/components/PageSpin';
import { AuthorizationContext } from 'src/contexts/authorizationContext';

const TwoFactorAuthorizedRoute: React.FC = () => {
  const { authorizationState, fetchAuthorizationState } = useAuthorization();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    fetchAuthorizationState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (authorizationState) {
      if (!authorizationState.userId) {
        navigate(routes.main);
      }

      if (!authorizationState.confirmationByPhone) {
        const searchParams = createSearchParams({
          returnUrl: `${location.pathname}${location.search}`,
          historyBack: 'true',
        }).toString();

        navigate(
          {
            pathname: routes.phoneConfirm,
            search: searchParams,
          },
          { replace: true }
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authorizationState]);

  // В сценарии редиректа нужно продолжать рендерить спинер. В противном случае до эффекта с редиректом успеет запуститься рендеринг вложенных компонентов.
  if (
    !authorizationState ||
    !authorizationState?.userId ||
    !authorizationState.confirmationByPhone
  ) {
    return <PageSpin />;
  }

  return (
    <AuthorizationContext.Provider value={authorizationState}>
      <Outlet />
    </AuthorizationContext.Provider>
  );
};

export default TwoFactorAuthorizedRoute;
